module.exports = __webpack_public_path__ + "static/penthouse-50661cd98f3416c5717a9d75ee4fa148.webp";